import React from "react";
import Modal from "components/Modal";
import Button from "components/Button";
import styles from "../../features/main/HaulPay/Carrier/RequestPay/Documents/style.module.scss";
import ChunkUploadFile from "../ChunkUploadFile";
import { UPLOAD_DOCUMENT_URLS } from "constants/routes";
import { UploadedFile } from "models/Component";
import UploadItem from "../../features/main/Loads/modules/UploadItem";
import FRAttachment from "../../features/main/HaulPay/modules/Shared/FRAttachment";
import { useSelector } from "react-redux";
import { selectUserDetails } from "../../store/user/selector";

function AddDocsNonFactored({
  isOpen,
  closeModal,
  onCloseModal,
  fundingRequestId
}: {
  isOpen: boolean;
  closeModal: () => void;
  confirmButton?: () => void;
  onCloseModal?: () => void;
  factoringId?: string;
  fundingRequestId?: string;
}) {
  const [uploadedFiles, setUploadedFiles] = React.useState<UploadedFile[]>([]);
  const userDetails = useSelector(selectUserDetails);
  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => {
        onCloseModal && onCloseModal();
        closeModal();
      }}
      wrapperClass="!my-auto desktop:!min-h-fit text-sm"
      dialogClass="!bg-foreground !p-6 !border !border-card !overflow-y-auto gap-6 rounded-md shadow-lg w-11/12 max-w-2xl"
      closeClass="!hidden">
      <div className="flex flex-col">
        <p className="mt-2 text-xl font-semibold">Create Non-Factored Request</p>
      </div>
      <div className={styles.uploadWrapper}>
        <ChunkUploadFile
          className="desktop:flex desktop:flex-col desktop:gap-4 desktop:text-lg "
          multiple
          urlCallback={
            UPLOAD_DOCUMENT_URLS({
              factoring_id: userDetails?.factoring_id,
              funding_request_id: fundingRequestId
            }).FR_ATTACHMENT
          }
          onUploadFinished={(files: any, fileId: string) => {
            const newFiles: UploadedFile[] = files.map((file: any) => ({
              name: file.name,
              size: file.fileSize,
              type: file.fileType,
              fileType: file.categories.split(","),
              url: file.preview_url,
              fileId: fileId
            }));
            setUploadedFiles([...uploadedFiles, ...newFiles]);
          }}
        />
        <div className="my-3">
          {uploadedFiles.map((file) => (
            <div key={file.name} className="-mx-2">
              <UploadItem file={file} />
            </div>
          ))}
        </div>
        {uploadedFiles.length > 0 ? (
          <p className="text-sm my-4">
            You can add, edit and delete documents from the non-Factored tab
          </p>
        ) : (
          <p className="text-sm text-red-500 my-4">
            Please attach at least 1 document to complete creating this Non-Factored transaction.
          </p>
        )}
        <FRAttachment
          label="Collated Billing PDF"
          url={`/factoring/funding/request/${fundingRequestId}/files/?document=collated`}
        />
      </div>
      <div className="flex justify-end px-2 mt-6">
        <Button
          type="button"
          onClick={() => {
            onCloseModal && onCloseModal();
            closeModal();
          }}
          className="self-end text-white bg-orange-500 rounded-full w-30 h-9 hover:bg-orange-600">
          Finish
        </Button>
      </div>
    </Modal>
  );
}

export default AddDocsNonFactored;
